export default __webpack_public_path__ + "static/media/self_realization.198661a1.jpg";